import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        updateForm: '=',
        formModel: '=',
        update: '&',
        cancel: '&'
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.cancel()"></button>
            <h2>{{ 'general.Manage translations' | translate }}</h2>
        </div>
        <div class="modal-body form translation">
            <form-wrapper form="vm.form">
                <table class="data01">
                    <tr>
                        <th>{{ 'general.Label ' | translate }}</th>
                        <th>{{ vm.defaultLanguage }} <small>({{ 'translation.default' | translate}})</small></th>
                        <th ng-repeat="(code, value) in vm.languages" ng-if="code!==vm.defaultLanguage">
                            <label><input ng-disabled="!vm.canManageForm" type="checkbox" ng-model="vm.languages[code]"
                            ng-click="vm.toggleCheckbox(code)"> {{ code }}</label>
                        </th>
                    </tr>
                    <tr>
                        <td>{{ 'translation.Form name' | translate }}*</td>
                        <td class="input active">
                            <form-row-wide error="vm.form.errors.formI18ns[vm.defaultLanguage].name">
                                <div class="items">
                                    <input ng-disabled="!vm.canManageForm" ng-model="vm.form.model.formI18ns[vm.defaultLanguage].name" class="form-control">
                                    <form-row-wide-error></form-row-wide-error>
                                </div>
                            </form-row-wide>
                        </td>
                        <td class="input" ng-repeat="(code, value) in vm.languages" ng-if="code!==vm.defaultLanguage" ng-class="{'active': value}">
                            <form-row-wide error="vm.form.errors.formI18ns[code].name">
                                <div class="items">
                                    <input ng-disabled="!vm.canManageForm" ng-model="vm.form.model.formI18ns[code].name" ng-if="value" class="form-control">
                                    <form-row-wide-error></form-row-wide-error>
                                </div>
                            </form-row-wide>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ 'translation.Form description' | translate }}</td>
                        <td class="input">
                        <form-row-wide error="vm.form.errors.formI18ns[vm.defaultLanguage].description">
                            <form-row-wideerror="vm.form.errors.formI18ns[vm.defaultLanguage].description">
                                <textarea ng-disabled="!vm.canManageForm" ng-model="vm.form.model.formI18ns[vm.defaultLanguage].description"
                                type="text" class="form-control"></textarea>
                                <form-row-wide-error></form-row-wide-error>
                            </form-row-wide>
                        </td>
                        <td class="input" ng-repeat="(code, value) in vm.languages" ng-if="code!==vm.defaultLanguage" ng-class="{'active': value}">
                            <form-row-wide error="vm.form.errors.formI18ns[code].description">
                                <textarea ng-disabled="!vm.canManageForm" ng-model="vm.form.model.formI18ns[code].description" ng-if="value"
                                type="text" class="form-control"></textarea>
                               <form-row-wide-error></form-row-wide-error>
                            </form-row-wide>
                        </td>
                    </tr>
                </table>
            </form-wrapper>
        </div>
        <div class="modal-footer">
        <ul class="actions01">
            <li ng-if="vm.canManageForm" class="primary"><button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Save' | translate }}</button></li>
            <li><button class="btn discrete" type="button" ng-click="vm.cancel()">{{ 'general.Cancel' | translate }}</button></li>
        </ul>
        </div>
    `
})
export default class {
    constructor ($scope, $rootScope, $translate, lodash, FORMS_SITE_ACCESS_ENUM, TokenService,
                 ModalService, FormService, FormFactory) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$translate = $translate;
        this.lodash = lodash;
        this.TokenService = TokenService;
        this.ModalService = ModalService;
        this.FormService = FormService;
        this.FORMS_SITE_ACCESS_ENUM = FORMS_SITE_ACCESS_ENUM;

        this.form = FormFactory.create(this.formModel, model => model.$update({
            id: model.id,
            expand: 'formI18ns,category,author,tags,activeI18n'
        }));
    }

    $onInit () {
        this.canManageForm = this.FormService.canManageForm(this.formModel);
        this.defaultLanguage = this.TokenService.getCompanyLanguage();
        const companySupportedLanguages = this.TokenService.getCompanySupportedLanguages();

        // this holds all available language codes as key and whether they are activated as value
        this.languages = {};
        this.lodash.forEach(companySupportedLanguages, (code) => {
            this.languages[code] = this.lodash.has(this.formModel.formI18ns, code);
        });
    }

    toggleCheckbox (code) {
        const confirmMessage = this.$translate.instant('translations.Are you sure you would like to remove this translation?');

        if (!this.languages[code]) {
            // leave checkbox checked
            this.languages[code] = !this.languages[code];
            this.ModalService.confirm(confirmMessage, 'medium')
                .then(() => {
                    // uncheck if confirmed
                    this.languages[code] = !this.languages[code];
                    // if language is disabled, make sure no error messages are left in ui
                    if (this.lodash.has(this.form.errors.formI18ns, code)) {
                        delete this.form.errors.formI18ns[code];
                    }
                });
        }
        else {
            // if language is enabled and form does not have current i18n, make one
            if (!this.lodash.has(this.form.model.formI18ns, code)) {
                this.form.model.formI18ns[code] = {};
            }
        }
    }

    deleteDisabledTranslations () {
        this.lodash.forEach(this.languages, (isActive, code) => {
            // if language is not active delete it from form
            if (!isActive && this.lodash.has(this.form.model.formI18ns, code)) {
                delete this.form.model.formI18ns[code];
            }
        });
    }

    beforeSave () {
        if (this.form.model.siteAccess === this.FORMS_SITE_ACCESS_ENUM.KEYS.ALL_SITES) {
            this.form.model.formSiteIds = [];
        }
        else {
            this.form.model.formSiteIds = this.formModel.sites.map(site => site.id);
        }
    }

    save () {
        this.beforeSave();
        this.deleteDisabledTranslations();
        this.form.save()
            .then(() => {
                this.update();
                this.updateForm.model.formI18ns = this.form.model.formI18ns;
                this.formModel.formI18ns = this.form.model.formI18ns;
                this.$scope.$emit('form:reload', this.formModel);
            })
        ;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/forms/translation/index.js